import { useState, useEffect } from "react";

export default function useCssProperty(css) {
  const [cssProperty, setCssProperty] = useState(null);

  useEffect(() => {
    // Funkce pro css
    const getVal = () => {
      const prop = getComputedStyle(document.documentElement).getPropertyValue(css).trim();
      setCssProperty(prop);
    };

    getVal();
  }, []);

  return cssProperty;
}
